import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
    name: 'isNotDate',
    standalone: false
})

export class isNotDatePipe implements PipeTransform {
  public transform(value: any, args?: any): any {

    if (!value) {
      return 'Нет данных';
    } else {
      return value;
    }


  }
}
